// extracted by mini-css-extract-plugin
module.exports = {"list":"QuoteList_list__1tQZO","sorting":"QuoteList_sorting__GvClu"};